import LibPhone from 'google-libphonenumber'
import phone from 'phone'
import isEmail from 'validator/lib/isEmail'
import {encode} from './gpt-3-encoder/Encoder.js'
export const clone = x => JSON.parse(JSON.stringify(x))
export const delay = seconds => new Promise(resolve => setTimeout(resolve, seconds * 1000))
export const capitalize = x => x ? x[0].toUpperCase() + x.slice(1) : x
const phoneUtil = LibPhone.PhoneNumberUtil.getInstance()
const owasp = require('owasp-password-strength-test')
const moment = require('moment')
import CryptoJS from 'crypto-js'

export function clearSigText(input, model) {
  let text = input || ""
  if (model !== 'gemini') text = text.replace(/<gemini-sig>[\s\S]*?<\/gemini-sig>/gi, "")
  if (model !== 'openai') text = text.replace(/<openai-sig>[\s\S]*?<\/openai-sig>/gi, "")
  if (model !== 'claude') text = text.replace(/<(signed|signature)>[\s\S]*?<\/\1>/gi, "")
  return text
}

export function parseSigText(input, model) {
  input = clearSigText(input, model)
  const result = [];
  const thinkRegex = /<think>([\s\S]*?)<\/think>/gi;

  let lastIndex = 0;
  let match;

  while ((match = thinkRegex.exec(input)) !== null) {
    const fullMatch = match[0];
    const inner = match[1];
    const start = match.index;
    const end = start + fullMatch.length;

    // Add plain text before this <think> block
    if (start > lastIndex) {
      result.push({
        type: "text",
        text: input.slice(lastIndex, start),
      });
    }

    // Extract optional <gemini-sig> inside the think block
    let sigMatch
    switch (model) {
      case 'gemini':
        sigMatch = inner.match(/<gemini-sig>([\s\S]*?)<\/gemini-sig>/i);
        break;
      case 'openai':
        sigMatch = inner.match(/<openai-sig>([\s\S]*?)<\/openai-sig>/i);
        break;
      case 'claude':
        sigMatch = inner.match(/<(signed|signature)>([\s\S]*?)<\/\1>/i);
        break;
    }

    let signature = null;
    let thought = inner;

    if (sigMatch) {
      signature = model === 'claude' ? sigMatch[2] : sigMatch[1];
      switch (model) {
        case 'gemini':
          thought = inner.replace(/<gemini-sig>[\s\S]*?<\/gemini-sig>/i, "").trim();
          break
        case 'openai':
          thought = inner.replace(/<openai-sig>[\s\S]*?<\/openai-sig>/i, "").trim();
          break
        case 'claude':
          thought = inner.replace(/<(signed|signature)>[\s\S]*?<\/\1>/i, "").trim();
          break
      }
    } else {
      thought = thought.trim();
    }

    result.push({
      type: "think",
      thought,
      signature,
    });

    lastIndex = end;
  }

  // Add trailing plain text
  if (lastIndex < input.length) {
    result.push({
      type: "text",
      text: input.slice(lastIndex),
    });
  }

  return result;
}


export function ellipsizePath(path, maxLength) {
  if (!path) {
    return
  }
  if (!Number.isInteger(maxLength) || maxLength < 1) {
    throw new TypeError("maxLength must be an integer >= 1");
  }

  if (path.length <= maxLength) return path;
  if (maxLength <= 3) return ".".repeat(maxLength);

  const ellipsis = "...";

  // Find last path separator so we can preserve the final segment.
  const lastSlash = Math.max(path.lastIndexOf("/"), path.lastIndexOf("\\"));

  // No separator: just middle-ellipsize the string.
  if (lastSlash === -1) {
    const keep = maxLength - ellipsis.length;
    const left = Math.ceil(keep / 2);
    const right = Math.floor(keep / 2);
    return path.slice(0, left) + ellipsis + path.slice(path.length - right);
  }

  const tail = path.slice(lastSlash); // includes slash + filename
  const minLeft = 1; // preserve at least one char from the start

  // Best case: keep full tail, trim only the middle.
  if (minLeft + ellipsis.length + tail.length <= maxLength) {
    const leftLen = maxLength - ellipsis.length - tail.length;
    return path.slice(0, leftLen) + ellipsis + tail;
  }

  // Tail itself is too long, so preserve some start and some end.
  const keep = maxLength - ellipsis.length;
  const right = Math.max(1, Math.floor(keep / 2));
  const left = Math.max(1, keep - right);

  return path.slice(0, left) + ellipsis + path.slice(path.length - right);
}

export const formatInt = num => num >= 10000 ? new Intl.NumberFormat().format(num) : num

export function formatName(input) {
  if (!input) return ''
  const result = input
    .replace(/([a-z])([A-Z])/g, '$1 $2')  // Convert camelCase to space-separated
    .replace(/_/g, ' ')                   // Convert underscores to spaces
    .replace(/\s+/g, ' ')                  // Ensure single spaces
    .trim()                                // Remove leading/trailing spaces
    .replace(/\b\w/g, char => char.toUpperCase()); // Capitalize each word  
  return result.toLowerCase()
}

export const selectAll = (element)  => {
  const range = document.createRange();
  
  // Select all the contents of the element
  range.selectNodeContents(element);
  
  
  // Get the current selection
  const selection = window.getSelection();
  
  // Remove any existing selections
  selection.removeAllRanges();
  
  // Add the new range to the selection
  selection.addRange(range);  

  // Collapse the range to the end point. This moves the caret to the end.
  //range.collapse(false);
}

export const scrollIntoView = (element, options) => {
  const rect = element.getBoundingClientRect();
  const offsetTop = rect.top + window.pageYOffset;
  window.scrollTo({
    top: offsetTop,
    behavior: 'instant'
  })
}

export const scrollOnKeyDown = ({getIndex, getLength, setIndex, enter, right, left, onHitStart, onHitEnd}) => (event) => {
  event.preventDefault()
  event.stopPropagation()
  //debugger
  let index = getIndex()
  switch (event.key) {
    case 'Enter':
      if (enter) enter()
      break;
    case 'ArrowRight':
      if (right) right()
      break;
    case 'ArrowLeft':
      if (left) left()
      break;
    case 'ArrowUp':
      index--
      break;
    case 'ArrowDown':
      index++
      break;
    case 'Home':
      index = 0
      break;
    case 'End':
      index = getLength() - 1
      break;
    default:
      return 
  }
  if (index < 0) {
    if (onHitStart) onHitStart()
  }  else if (index >= getLength()) {
    if (onHitEnd) onHitEnd()
  } else {
    setIndex(index)
  }
}

export const readTextFile = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = function(event) {
      resolve(event.target.result)
    }
    reader.onerror = function(event) {
      reject(event.target.error)
      console.error("File could not be read:", event.target.error);
    };
    reader.readAsText(file);
  })
}

export const copyToClipboard = async text => {
  try {
    navigator.clipboard.writeText(text)
  } catch (err) {
    console.error(err)
    //console.log(text)
  }
  await delay(0.5)
}

export const hash = async (input) => {
  return CryptoJS.SHA256(input).toString();
  const encoder = new TextEncoder();
  const data = encoder.encode(input);
  const hash = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(hash))
    .map(b => b.toString(16).padStart(2, '0'))
    .join('');
}

export function fromNow(date) {
  const fromNow = moment(date).fromNow().replace(/ ago/, '')
  const fixed = fromNow
        .replace(/.*a few seconds.*/, 'now')
        .replace(/.*a minute.*/, '1m')
        .replace(/.*an hour.*/, '1h')
        .replace(/.*a day.*/, '1d')
        .replace(/.*a month.*/, '1mo')
        .replace(/.*a year.*/, '1y')
        .replace(/ minutes?/, 'm')
        .replace(/ hours?/, 'h')
        .replace(/ days?/, 'd')
        .replace(/ months?/, 'mo')
        .replace(/ years?/, 'y')
  ////////console.log('fromNow', fromNow, '=>', fixed)
  return fixed
}

export const formatTokens = trainedTokens => {
  if (trainedTokens < 1000) {
    return trainedTokens + " tokens"
  }
  if (trainedTokens < 1000000) {
    return Math.round(trainedTokens / 1000) + "K tokens"
  }
  return parseFloat((trainedTokens / (1000* 1000)).toFixed(1)) + "M tokens"
}

export const countTokens = text => text ? encode(text).length : 0

export const randomElement = array => array[Math.floor(Math.random() * array.length)]

export const formatPhone = number => {
  const parsed = phoneUtil.parseAndKeepRawInput(number, 'US')
  return phoneUtil.format(parsed, LibPhone.PhoneNumberFormat.NATIONAL)
}

export const convertPhone = n => {
  let { countryCode, phoneNumber } = parsePhoneNumber(n)
  phoneNumber = '+' + countryCode + phoneNumber
  const converted = phone(phoneNumber)
  return converted[0]
}

export const validatePassword = pw => {
  const result = owasp.test(pw)
  return result
}

export const validateEmail = email => {
  return isEmail(email)
}

export const parsePhoneNumber = number => {
  try {
    const parsed = phoneUtil.parseAndKeepRawInput(number, 'US')
    return { countryCode: parsed.getCountryCode(), phoneNumber: parsed.getNationalNumber() }
  } catch (ignored) {
    return { countryCode: 1, phoneNumber: number }
  }
}

export const normalizePhone = n => {
  const { countryCode, phoneNumber } = parsePhoneNumber(n)
  return '+' + countryCode + phoneNumber
}

export const mergeFields = (...xs) => {
  const result = {}
  for (const x of xs) {
    for (const i in x) {
      result[i] = x[i]
    }
  }
  return result
}

export const joinWith = (a, s) => {
  let sep
  const result = []
  for (const x of a) {
    if (sep) result.push(sep)
    result.push(x)
    sep = s()
  }
  return result
}

export const search = (input, getKey, getTerms, q) => {
  const normalize = term => term.replace(/[&,()/-]/g, ' ').toLowerCase().trim()
  const origSearchTerm = normalize(q)
  const searchTerms = q ? origSearchTerm.split(/\s+/) : []
  const matches = {}
  const seen = {}
  for (const x of input) {
    const t = getTerms(x)
    const origTerm = normalize(t)
    const terms = origTerm.split(/\s+/)
    //console.log('terms', terms)
    let matched = 0
    if (origTerm === origSearchTerm) {
      matched += 10
    }
    if (terms.length > 1) {
      searchTerms.forEach(searchTerm => {
        if (origTerm.startsWith(searchTerm)) {
          matched += 5
        }
      })
    }
    const id = getKey(x)
    if (seen[id]) {
      return
    }
    seen[id] = true
    terms.forEach(term => {
      if (term.length < 2) return
      searchTerms.forEach(searchTerm => {
        if (!searchTerm) return
        if (term === searchTerm) {
          matched += 4
        }
        else if (term.startsWith(searchTerm)) {
          matched++
        }
        else if (searchTerm.startsWith(term)) {
          matched += 0.25
        }
        //console.log('matched', searchTerm, term, matched)
      })
    })
    if (matched > 0) {
      let match = matches[id]
      if (!match) {
        match = {
          key: t,
          value: x,
          match: matched
        }
        matches[id] = match
      } else {
        match.match += matched
      }
      //console.log('match', match)
    }
  }
  const results = Object.values(matches)
  results.sort((match1, match2) => {
    let cmp = -(match1.match - match2.match)
    if (!cmp) {
      const s1 = match1.key
      const s2 = match2.key
      cmp = s1.localeCompare(s2)
    }
    //console.log(s1, s2, cmp)
    return cmp
  })
  return results.map(x => x.value)
}

export const formatAddress = address_components => {
  const getShortName = (type) => {
    const c = address_components.find(x => x.types.find(y => y === type))
    return c ? c.short_name : ''
  }
  let streetNumber = getShortName('street_number')
  const subpremise = getShortName('subpremise')
  if (subpremise) streetNumber += ' ' + subpremise
  const street = getShortName('route')
  const city = getShortName('locality')
  const state = getShortName('administrative_area_level_1')
  const zip = getShortName('postal_code')
  const address = `${streetNumber} ${street}, ${city}, ${state} ${zip}`
  return address
}

export const formatDistance = meters => {
  let miles = (meters * 0.000621371).toFixed(1)
  if (miles.endsWith('.0')) {
    const dot = miles.lastIndexOf('.')
    miles = miles.substring(0, dot)
  }
  return `${miles} mi`
}

export const arrayEq = (x, y) => {
  if (!x) {
    return !y
  } else if (!y) {
    return false
  }
  if (x.length !== y.length) {
    return false
  }
  for (let i = 0; i < x.length; i++) {
    if (x[i] !== y[i]) {
      return false
    }
  }
  return true
}

export function startOfDay(date)  {
  return moment(date).local().startOf("day").toDate()
}
export function startOfWeek(date)  {
  return moment(date).local().startOf("isoweek").toDate()
}
export function startOfMonth(date)  {
  return moment(date).local().startOf("month").toDate()
}
export function startOfYear(date)  {
  return moment(date).local().startOf("year").toDate()
}
export function endOfWeek(date)  {
  return moment(date).local().endOf("isoweek").toDate()
}
export function endOfMonth(date)  {
  return moment(date).local().endOf("month").toDate()
}
export function endOfDay(date)  {
  return moment(date).local().endOf("day").toDate()
}
export function endOfYear(date)  {
  return moment(date).local().endOf("year").toDate()
}


export function setCaretPositionFromEvent(element, event) {
  if (!element) return;
  if (!event) return
  if (event.clientX === undefined) {
    return
  }
  element.focus()
  const selection = window.getSelection();
  if (!selection) return;

  // Clear any existing selection ranges
  selection.removeAllRanges();

  let range = null;
  if (document.caretRangeFromPoint) {
    // Most browsers support this method
    range = document.caretRangeFromPoint(event.clientX, event.clientY);
  } else if (document.caretPositionFromPoint) {
    // Fallback for browsers like Firefox
    const pos = document.caretPositionFromPoint(event.clientX, event.clientY);
    range = document.createRange();
    range.setStart(pos.offsetNode, pos.offset);
  }

  if (range) {
    // Optional: Verify the range is within the target element
    if (!element.contains(range.startContainer)) {
      console.warn('Click event occurred outside the specified element.');
      return;
    }
    selection.addRange(range);
  }
}
